module.exports = __webpack_public_path__ + "static/media/2-Fargene (1).191fdde8.mp3";